import i18n from 'i18next'
import React from 'react'
import PageHeader from '#components/m/PageHeader'
import Headline from '#components/a/Headline'
import WissensportalFilterModal from '#components/o/Wissensportal/WissensportalFilterModal'
import RenderFilters from '#components/m/Wissensportal/RenderFilters'
import PropTypes from 'prop-types'
import {removeFilter} from '#components/o/Wissensportal/WissensportalHelper'

function WissensportalAusbilderTrainerHeaderWithFilter({uniqueCourses, uniqueModules, filterCallback, selectedFilters}) {

  const confirmCallback = filters => {
    filterCallback(filters)
  }

  const removeFilterCallback = item => {
    const newFilters = removeFilter(item, selectedFilters)
    filterCallback(newFilters)
  }

  const filterButton = (
    <button type='button' className='link link--primaryLight' data-testid='wissensportal-filter-button'>
      {i18n.t('wissensportal_show_filter')}
    </button>
  )

  const ifFiltersExist =
    selectedFilters.courses.length > 0 || selectedFilters.modules.length > 0 || selectedFilters.status

  return <>
    <PageHeader
      headline={<Headline importance={2} modifier='section' text={i18n.t('wissensportal')} />}
      button={
        <WissensportalFilterModal
          trigger={filterButton}
          confirmCallback={confirmCallback}
          allCourses={uniqueCourses}
          allModules={uniqueModules}
          parentFilters={selectedFilters}
        />
      }
    />
    {ifFiltersExist && (
      <div className='filters'>
        <span className='text'>{`${i18n.t('wissensportal_selected_filters')}:`}</span>
        <RenderFilters removeFilterCallback={removeFilterCallback} selectedFilters={selectedFilters} />
      </div>
    )}
  </>

}

WissensportalAusbilderTrainerHeaderWithFilter.propTypes = {
  uniqueCourses: PropTypes.array,
  uniqueModules: PropTypes.array,
  filterCallback: PropTypes.func,
  selectedFilters: PropTypes.object
}


export default WissensportalAusbilderTrainerHeaderWithFilter
